import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/montserrat";
import "@fontsource/great-vibes";
import "./index.css";
import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import Tailwind from 'primereact/passthrough/tailwind';
// import "primereact/resources/themes/tailwind-light/theme.css";
import classNames from "classnames";
import { BrowserRouter as Router } from "react-router-dom";
import { CartProvider } from "./context/CartContext";



const MyDesignSystem = {
  button: {
    root: ({ props }) => ({
      className: classNames(
        'inline-flex items-center justify-center',
        'bg-primary text-white font-bold py-2 px-4 rounded', // Tailwind classes!
        'hover:bg-primary/80', // Slightly darker on hover
        {
          'opacity-50 cursor-not-allowed': false
        }
      )
    })
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ unstyled: true, pt: MyDesignSystem }} >
      
    <Router>
      <CartProvider>
        <App />
      </CartProvider>
    </Router>
    </PrimeReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
